
import { ModelLookupChosenValue } from '@/models/main';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class AutocompleteWithGeneric extends Vue {
  @Prop({ type: Number, required: true }) private readonly stop!: number;
  @Prop({ type: Number, required: false }) private readonly tabIndex!: number;
  @Prop({ type: Object, required: false }) private readonly chosen!: ModelLookupChosenValue;
  @Prop({ type: Boolean, required: false }) private readonly disabled!: boolean;
  @Prop({ type: Function, required: true }) private autocomplete!: (
    params: string,
  ) => Promise<ModelLookupChosenValue[]>;

  private input = '';
  private inputVal = '';
  private itemSearch: ModelLookupChosenValue[] = [];
  private loading = false;

  private search(val: string | null) {
    if (val === this.input || val == null) {
      return;
    } else {
      this.inputVal = val;
      if (val?.length >= 3) {
        this.itemSearch = [];
        this.loading = true;
        this.autocomplete(val)
          .then(data => {
            this.itemSearch = data;
          })
          .catch(e => console.log(e))
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
  private change() {
    const item = this.itemSearch.filter(x => x.name === this.input)[0];
    if (item) {
      this.input = item.name;
      this.inputVal = item.name;
      this.$emit('change', this.stop, item);
    } else {
      this.$emit('clear', this.stop);
    }
  }

  private blur() {
    if (this.inputVal && this.input !== this.inputVal && this.inputVal.length > 0) {
      this.input = '';
      this.$emit('clear', this.stop);
    }
  }

  @Watch('chosen', { immediate: true, deep: true })
  private watchToChosen() {
    if (this.input !== this.chosen.name) {
      this.inputVal = this.chosen.name;
      this.itemSearch = [];
      this.loading = true;
      this.autocomplete(this.chosen.name)
        .then(data => {
          const find = data.find(x => x.product_id === this.chosen.product_id);
          if (find) {
            this.itemSearch = data;
            this.input = find.name;
            this.$emit('change', this.stop, find);
          }
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
